// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const ilinkstvColors: ColorType = { ...colorPalette }

export const lightTheme = {
  colors: ilinkstvColors,
  background: {
    primary: '#fafafa',
    secondary: '#fafafa',
    highlight: ilinkstvColors.light,
    select: '#fafafa',
    footerTop: '#eee',
  },
  text: {
    primary: ilinkstvColors.dark,
    secondary: ilinkstvColors.grayText,
    disabled: ilinkstvColors.dark,
    link: ilinkstvColors.dark,
    hint: ilinkstvColors.dark,
    highlight: ilinkstvColors.primary,
    gray: ilinkstvColors.grayText,
    seeAll: 'rgba(52, 73, 94, 0.8)',
    primaryContrast: '#ffffff',
  },
  border: {
    primary: '#dddddd',
    gray: '#ddd',
  },
  filter: {
    primary: '#43484d',
    secondary: '#43484d',
    disabled: ilinkstvColors.grayLabel,
    highlight: '#fff',
  },
  tabs: {
    bg: '#fafafa',
    containerBg: ilinkstvColors.dark,
    color: ilinkstvColors.dark,
    border: ilinkstvColors.primary,
    scrollbarThumb: ilinkstvColors.primary,
    programTitle: ilinkstvColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: 'rgba(221, 221, 221, 0.8)',
        hover: ilinkstvColors.dark,
        selected: ilinkstvColors.dark,
        progress: rgba(ilinkstvColors.primary, 0.3),
        past: rgba(ilinkstvColors.primary, 0.3),
        pastSelected: ilinkstvColors.dark,
        pastHover: ilinkstvColors.dark,
        empty: 'rgba(221, 221, 221, 0.3)',
        emptyProgress: rgba(ilinkstvColors.primary, 0.1),
      },
      text: {
        empty: ilinkstvColors.grayLabel,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #fafafa 0%,${rgba('#fafafa', 0.97)} 13.03%,${rgba('#fafafa', 0.69)} 43.24%,${rgba(
          '#fafafa',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0,#fafafa 0%,${rgba('#fafafa', 0.73)} 34.97%,${rgba('#fafafa', 0)} 100%);`,
    },
  },
  card: {
    title: ilinkstvColors.dark,
    subTitle: ilinkstvColors.grayText,
    bg: ilinkstvColors.dark,
    number: ilinkstvColors.grayBorder,
    boxShadow: 'rgba(221, 221, 221, 0.8)',
    loaderBackgroundImage: 'linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%)',
  },
  dimension: {},
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
